import * as datetime from 'locutus/php/datetime'
import user from './user'

export default {
    ...datetime,
    
    isTimestamp(data) {
        return /^\d+$/.test(data)
    },
    
    toUserTimestamp(data) {
        if(!this.isTimestamp(data)) {
            data = this.strtotime(data)
            data = data + user.getInfo().timeDiff
        }
        
        return data
    },
    
    parseDateFormat(str) {
        var s = str.split('/')
        let d = new Date()
        let t = d.toLocaleTimeString()
        if(s.length>1)
            return this.toGmtTimestamp(s[2]+'-'+(s[1])+'-'+s[0] +' '+t)
    },
    
    toGmtTimestamp(data) {
        if(!this.isTimestamp(data)) {
            data = this.strtotime(data)
            data = data + user.getInfo().timeDiff
        }
        
        return data
    },
    
    formatSend(data, isTimestamp = false, isDateOnly = false) {
        if(!isTimestamp && !this.isTimestamp(data))
            data = this.strtotime(data)
        
        let format = isDateOnly ?'Y-m-d 00:00:00+00:00' :'Y-m-d H:i:s+00:00'
        
        return this.date(format, data).replace(' ', 'T')
    },
    
    formatDisplay(data, isTimestamp = false, format=null) {
        if(!isTimestamp && !this.isTimestamp(data))
            data = this.strtotime(data)
        
        return this.date(format || user.dateTimeFormat, data)
    },
    
    convertAndDisplay(data, format) {
        data = this.toUserTimestamp(data)
        return this.formatDisplay(data, true, format)
    },
    
    convertAndSend(data, isDateOnly = false) {
        data = this.toGmtTimestamp(data)
        return this.formatSend(data, true, isDateOnly)
    },
    
    gmtTimestampToJsTimestamp(timestamp) {
        return timestamp * 1000
    },
    
    jsTimestampToGmt(timestamp) {
        if(!timestamp)
            timestamp = (new Date()).getTime()
        
        return parseInt(timestamp / 1000)
    }
}
